<template>
  <div>
    <div class="md-layout input-layout">
      <div class="md-layout-item md-size-10">
        <!-- Sale Type -->
        <validated-select-input
          label="Sale Type"
          :prefixLabel="prefixLabel"
          v-model="sale_type"
          :options="options.assets_sale_types"
        ></validated-select-input>
      </div>
        <!-- Supplier Name -->
        <!-- {{options.asset_security_details}} -->
        <validated-autocomplete-input
          class="md-layout-item md-small-size-100 md-size-20"
          label="Supplier Name"
          :prefixLabel="prefixLabel"
          v-model="security.supplier_name"
          :options="options.introducer_details"
          autocompleteDisabled
        />
        <!-- Supplier Phone -->
        <validated-text-input
          class="md-layout-item md-small-size-100 md-size-15"
          label="Supplier Phone"
          v-model="security.supplier_contact_number"
          :prefixLabel="prefixLabel"
          prefix="+"
          :minLength=7
          :maxLength=15
          errormsg="Please enter a valid phone number, format can contain 7 to 15 digits"
        />
        <!-- Supplier Email -->
        <validated-text-input
          class="md-layout-item md-small-size-100 md-size-30"
          label="Supplier Email"
          v-model="security.supplier_contact_email"
          :prefixLabel="prefixLabel"
        />
        <a v-if="(application.owners[1] ? (application.owners[1].user_id == 1243) : false)
          && cs_listing_security_types.includes(securityType)"
          :href="application.loan.cs_listing_url"
          target="_blank"
          class="md-primary md-layout-item">
            Carsales Listing
            <md-icon>launch</md-icon>
            <md-tooltip md-direction="top">Open</md-tooltip>
        </a>
        <!-- Supplier Abn-->
        <validated-autocomplete-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Supplier Abn"
            :prefixLabel="prefixLabel"
            v-model="security.supplier_abn"
            :maxLength=11
        />
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import filters from "@/components/utils/filters";
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import GroupCardRow from "@/components/Cards/GroupCardRow";
import PropertyView from '@/components/ApplicationSummary/PropertyView';
import ValidatedInput from "../../ValidatedInput/ValidatedInput";
import ValidatedAutocompleteInput from "../../ValidatedInput/ValidatedAutocompleteInput";

export default {
  components: {
    ValidatedInput,
    ValidatedAutocompleteInput,
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    PropertyView,
  },
  props: {
    securityType: {
      type: String,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    prefixLabel: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      cs_listing_security_types : ['vehicle', 'marine' , 'leisure']
    }
  },
  watch: {
    "security.supplier_name"() {
      if (this.security.supplier_name) {
        this.fetch_introducer();
      }
    }
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      options: "options",
    }),
    security: {
      get() {
        return this.application.loan.asset[this.securityType];
      },
      set(security) {
        this.$emit("input", security);
      }
    },
    application: {
      get() {
        return this.value;
      },
      set(application) {
        this.$emit("input", application);
      }
    },
    sale_type: {
      get() {
        if (this.security.private_sale > 0) {
          return this.options.assets_sale_types[this.security.private_sale-1];
        }
        else {
          return this.security.private_sale;
        }
      },
      set(saleType) {
        return this.security.private_sale = saleType;
      }
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    async fetch_introducer() {
      try {
        let payload = {
          trading_name: this.security.supplier_name
        }
        const response = await this.$store.dispatch("load_introducer", payload);
        this.security.supplier_contact_email = response.data.introducer_email;
        this.security.supplier_contact_number = response.data.introducer_number;
      } catch (err) {
        console.log(err);
      }
    }
  },
  async beforeCreate() {
    const params = {
      types: [
        'assets_sale_types',
        'introducer_details',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
}
</script>
